import { RewardTag } from '@repo/ui'
import type { NotificationAccentColor } from '../../types/domain'
import { CloseNotificationIcon } from '../CloseNotificationIcon'

type NotificationRewardTagProps = Readonly<{
  accentColor: NotificationAccentColor
  icon: React.ReactNode
  label: string
  reward: string
  cta?: {
    icon: React.ReactNode
    onClick: () => void
    className?: string
  }
  onClose: () => void
}>

export function NotificationRewardTag({ 
  accentColor, 
  icon, 
  label, 
  reward, 
  cta, 
  onClose 
}: NotificationRewardTagProps) {
  return (
    <RewardTag
      accentColor={accentColor}
      cta={cta || {
        icon: <CloseNotificationIcon />,
        onClick: onClose,
        className: 'group'
      }}
      icon={icon}
      label={label}
      reward={reward}
    />
  )
}